import React from "react";
import deliveryTShirtsStyles from "../TShirtsStocking.module.css";
import { COMPLETED } from "../t-shirt/TShirtsStockingStatus";

const TShirtsStockingStatusCompleted = () => {
    return <div className={deliveryTShirtsStyles.Status}>{COMPLETED.render()}</div>;
};

export default TShirtsStockingStatusCompleted;
